import { computed } from "vue";

import { useViewState } from "./useViewState";

export function useTableConfig() {
  const viewState = useViewState();

  const tableParams = computed(() => {
    return {
      headers: [
        {
          text: "Position",
          sortable: true,
          value: "position",
        },
        {
          text: "Occupied by",
          sortable: false,
          value: "occupied_by",
          img: "icons/briefcase.svg",
        },
        {
          text: "Position Readiness",
          sortable: false,
          value: "readiness",
        },
        {
          text: "Exclude from Average",
          sortable: false,
          value: "average",
          width: "120px",
          wordBreak: true,
          centerField: true,
        },
        {
          text: "",
          sortable: false,
          value: "chatter",
          width: "70px",
        },
      ],
      columns: [
        {
          field: "",
          component: "PositionCard",
          props: (item) => ({
            class: "my-4 datatable-text-content",
            "data-position-id": item.id,
            count: item?.roles_count || 0,
            code: (item?.code_str ? item.code_str.split(" ")[0] : item?.code)?.toString() || "",
            name: item?.name || "",
            occupied: item?.primary_position_effective_on ? "1" : "not",
            value: item?.capacity || 1,
            clickPopup: true,
            hideCapacitySelector: true,
          }),
          events: (item) => ({
            openPopup: async () => {
              await viewState.openPositionDetails(item);
            },
          }),
        },
        {
          field: "",
          component: "ReadinessOrgOccupationTag",
          props: (item) => ({
            class: "my-4",
            ...viewState.getReadinessOrgOccupationTagProp(item),
          }),
        },
        {
          field: "",
          component: "EmployeeReadinessBar1",
          props: (item) => ({
            class: "my-4",
            ...viewState.getPositionReadinessProps(item),
          }),
        },
        {
          field: "",
          component: "SwitchButton",
          props: (item) => ({
            class: "my-4",
            ...viewState.getSwitcherProps(item),
          }),
          events: (item) => ({
            onChange: async (value) => {
              viewState.updatePositionExcludeFromAvgValue(item, value);
            },
          }),
        },
        {
          field: "",
          component: "ChatterButton",
          props: () => ({
            class: "my-4",
          }),
          events: (item) => ({
            onClick: () => {
              viewState.openPositionChatterModal(item);
            },
          }),
        },
      ],
      filters: {
        values: viewState.state.filters.values,
        searchText: viewState.state.filters.searchText,
      },
      hideTopSection: true,
      hideActiveNo: false,
      activeRecords: {
        field: "current_status",
        value: "active",
      },
      actionLabel: "Recalculate All",
      showActionButton: viewState.state.filters.needsRecalculation ? false : true,
      hideGridView: true,
      hideButtonIcon: true,
      hideButtonInMessage: true,
      hideFilterBtn: true,
      getRowStyle: (item) => ({
        backgroundColor: item.position?.data?.status === "active" ? "#ECFDF3" : "#FFFFFF",
      }),
    };
  });
  return {
    tableParams,
  };
}
